// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".register-preview--layout {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  min-height: 365px; }\n  .register-preview--layout .register-preview--data-container {\n    width: 100%; }\n  .register-preview--layout .register-preview--actions {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    margin-top: auto;\n    width: 100%; }\n", ""]);
// Exports
module.exports = exports;
